<template>
  <div>
    <Head title="Моё оборудование" />
    <h1 class="mb-8 text-3xl font-bold">Моё оборудование</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Статус:</label>
        <select v-model="form.status" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="10">Доступно</option>
          <option value="20">Перемещается</option>
          <option value="20">Недоступно</option>
        </select>
        <label class="block text-gray-700">Тип оборудования:</label>
        <select v-model="form.type" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="10">Медицинское</option>
          <option value="20">Компьютерное</option>
          <option value="30">Мебель</option>
        </select>
      </search-filter>
      <form @submit.prevent="scan" @change="scan">
        <file-input-qr v-model="scanForm.image" onchange="scan()" title="" class="pr-6 w-full lg:w-1/2" />
      </form>

    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Инв.№</th>
          <th class="pb-4 pt-6 px-6">Наименование</th>
          <th class="pb-4 pt-6 px-6">Расположение</th>
          <th class="pb-4 pt-6 px-6">Статус</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="inventory in inventories.data" :key="inventory.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/inventories/${inventory.id}/edit`">
              {{ inventory.sku }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/inventories/${inventory.id}/edit`" tabindex="-1">
              {{ inventory.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/inventories/${inventory.id}/edit`" tabindex="-1">
              {{ inventory.branch_name }} / {{ inventory.department_name }} / {{ inventory.room }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/inventories/${inventory.id}edit/`" tabindex="-1">
              {{ inventory.status_name }}
            </Link>
          </td>
        </tr>
        <tr v-if="inventories.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Список оборудования пуст</td>
        </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="inventories.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import TextInput from "@/Shared/TextInput.vue";
import FileInput from "@/Shared/FileInput.vue";
import LoadingButton from "@/Shared/LoadingButton.vue";
import FileInputQr from "@/Shared/FileInputQr.vue";

export default {
  components: {
    FileInputQr,
    LoadingButton,
    FileInput,
    TextInput,
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    inventories: Object,
  },
  data() {
    return {
      form: {
        filters: Object,
        status: this.filters.status,
      },
      scanForm: {
        image: ''
      }
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    scan() {
      this.$inertia.post(`/inventories/scan`, this.scanForm)
    }
  },
}
</script>
